import { CircularProgress, makeStyles, Typography } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';
import moment from "moment-timezone";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faWalking , faCar} from '@fortawesome/free-solid-svg-icons';
import { hasArrived } from 'util/bookingStates';
import { useRecoilValue } from 'recoil';
import { bookingState } from 'pages/CustomerBooking/RecoilState';

const useStyles = makeStyles((theme) => {
  return {
    text: {
      color: "white",
      fontWeight: "bold",
    },
    "bubble": {
      boxSizing: "border-box",
      position: "absolute",
      background: theme.palette.secondary.dark,
      width: 'max-content',
      height: 'fit-content',
      minHeight: theme.spacing(3),
      padding: theme.spacing(1),
      borderRadius:theme.shape.borderRadius,
      top: -25,
      left: 0,
      transform: "translateX(-50%) translateY(-100%)",
      boxShadow: theme.shadows[9],
      
      "&::after": {
        content: '""',
        position: "absolute",   
        width:0, 
        height:0,
        border: "10px solid transparent",
        borderTopColor: theme.palette.secondary.dark,
        top: "100%",
        left: `calc(50% - 10px)`
        
      }
    }
  }
})

const ETA = ({eta, state, waitingDistance=100000, travelMethod="walking"}) => {
  const classes = useStyles()
  const booking = useRecoilValue(bookingState)

  const travelIcon = useMemo(() => {
    switch (travelMethod) {
      case "driving":
        return <FontAwesomeIcon className={classes.text} icon={faCar}/>
        break;
      default:
        return <FontAwesomeIcon className={classes.text} icon={faWalking}/>
    }
  }, [classes.text, travelMethod]);

  const etaText = useMemo(() => {
    let returnText = waitingDistance > 0.1 ? 'En Route' : 'Arriving'
    if (hasArrived(booking)) {
      returnText = 'Arrived'
    }
    return returnText 
  }, [booking, waitingDistance]);

  return (
    <div className={classes.bubble}>
      <Typography className={classes.text} variant="button" color="textPrimary" align="center" display="block">
        {etaText}
      </Typography>
      <Typography className={classes.text} variant='caption' color="textPrimary" align="center" display="block">
      ETA: {moment.duration(eta, 'seconds').humanize()} {travelIcon}
      </Typography>
    </div>
  )
}

export {ETA}